export interface MonsterMovementDefinition {
  profile: string;
  speedPixelsPerSecond: number;
}

export function parseMonsterMovement(
  value: unknown,
  monsterId: string,
): MonsterMovementDefinition {
  if (!value || typeof value !== "object")
    throw new TypeError(`${monsterId} has an invalid movement definition`);

  const movement = value as Partial<MonsterMovementDefinition>;
  if (
    typeof movement.profile !== "string" ||
    movement.profile.trim().length === 0 ||
    typeof movement.speedPixelsPerSecond !== "number" ||
    !Number.isFinite(movement.speedPixelsPerSecond) ||
    movement.speedPixelsPerSecond <= 0
  )
    throw new TypeError(`${monsterId} has an invalid movement definition`);

  return movement as MonsterMovementDefinition;
}
